/**
 * @fileOverview Date 扩展类
 * @author ZD @zd.com
 * @version 0.0.1
 */

/**
* @description 日期格式化
* @param { String } fmt 格式
* @example new Date().format('yyyyMMddhhmmss');
*/
Date.prototype.format = function (fmt = "yyyy-MM-dd") {
    var o = {
        "M+": this.getMonth() + 1, //月份
        "d+": this.getDate(), //日
        "h+": this.getHours(), //小时
        "m+": this.getMinutes(), //分
        "s+": this.getSeconds(), //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        "S": this.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}
Date.prototype.getDayCh = function () {
    return ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"][this.getDay()];
}
Date.prototype.before = function (num, unit) {
    return this.getTime() - num * ({
        "year": 86400000 * this.getYearDay(),
        "month": 86400000 * 30,
        "week": 86400000 * 7,
        "day": 86400000,
        "hour": 3600000,
        "minute": 60000,
    }[unit] || console.error("时间匹配错误！"));
}
Date.formatSeconds = function (value) {
    var theTime = parseInt(value);// 秒
    var theTime1 = 0;// 分
    var theTime2 = 0;// 小时
    if (theTime > 60) {
        theTime1 = parseInt(theTime / 60);
        theTime = parseInt(theTime % 60);
        if (theTime1 > 60) {
            theTime2 = parseInt(theTime1 / 60);
            theTime1 = parseInt(theTime1 % 60);
        }
    }
    var result = "" + parseInt(theTime) < 10 ? "0" + theTime : theTime;
    if (theTime1 > 0) {
        result = "" + parseInt(theTime1) + ":" + result;
    }
    if (theTime2 > 0) {
        result = "" + parseInt(theTime2) + ":" + result;
    }
    return result;
}
Date.prototype.getYearDay = function () {
    return this.getFullYear() % 4 === 0 ? 366 : 365;
}
Date.prototype.monthStart = function () {
    return new Date(new Date().format("yyyy/MM")).getTime()
}
Date.prototype.monthEnd = function () {
    const onDate = new Date().format("yyyy/MM");
    const onMonth = parseInt(onDate.substring(onDate.length - 2));
    let nextMonth = onMonth === 12
        ? "01"
        : onMonth + 1;
    if (nextMonth.length === 1) nextMonth = "0" + nextMonth;
    return new Date(onDate.substring(0, 5) + nextMonth).getTime();
}